import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

import ReactGA from 'react-ga';

import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Button from '../../collections/LinkButton/LinkButton';
import Card from '../../components/Card/Card';
import Footer from '../../components/Footer/Footer';

import SingleOfferApp from './SingleOfferApp';
import DoubleOffer from './DoubleOffer';

import { media } from '../../utilities/style-utilities';

import SessionStorage from '../../storage/SessionStorage/SessionStorage';
import { fontUbuntuLight } from '../../utilities/utilities';

const Retailer = styled.div`
  flex: 0 1 auto;
  margin: 0.2rem;
   max-width: 32.3%;
    width: 100%;
`;
const RetailerLink = styled.a`
  cursor: pointer;
`;
const RetailerImg = styled.img`
  max-width: 100%;
  width: 100%;
  height: auto;
  display:block;
`;

const Offer = styled.div`
  flex: 0 0 auto;
  border-radius: 0.5rem;
  margin: 0 0.2rem;
  padding-bottom: 1rem;
  /* width: 100%; */
`;

const OfferLink = styled.a`
  cursor: pointer;
`;

const OfferImg = styled.img`
  max-width: 100%;
  height: auto;
  display:block;
  margin: 0 auto;
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 1.5rem 0 0.5rem 0;
  &::before {
    content: '';
    border-top: 2px solid #e6e6e6;
    position: absolute;
    left: 1rem;
    right: 1rem;
    top: 0;
  }
`;

const StyledButton = styled(Button)`
  width: auto;
  padding-left: 3rem;
  padding-right: 3rem;
  ${ media.tablet`
    width: 100%;
  `}
`;


const StyledH2 = styled.h2`
  display:block;
  color: ${props => props.textColor ? props.textColor : '#0d1b58'};
  font-size: 1.5em;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  font-weight: normal;
  margin-bottom: 1rem;
  ${ media.desktop`
    font-size: 1.25em;
  `}
  ${ media.tablet`
    display: none;
  `}
`;

class BalancePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: '',
      height: '',
      store: {
        name: '',
        balance: 0,
        retailers: [],
        offers: [],
      }
    }
  };

  updateDimensions = () => {
    let w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName('body')[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
      height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

    this.setState({width: width, height: height});
  }

  componentWillMount = () => {
    this.updateDimensions();
  }
  componentDidMount = () => {
      ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);

      window.addEventListener("resize", this.updateDimensions);

      this.props.update({
        cardActivation: {
          activeStep: 1,
          error: {
            isVisible: false,
            message: '',
            type: `error`
          }
        },
        pinRetrieval: {
          activeStep: 1,
          error: {
            isVisible: false,
            message: '',
            type: `error`
          }
        }
      }, (state) => {
        if (SessionStorage.getSessionStorageItem('store') !== null) {
          this.setState({
            store: JSON.parse(SessionStorage.getSessionStorageItem('store'))
          });
          
        } else {
          let username = ''
          if (state.cardDetails.FirstName !== null && state.cardDetails.FirstName !== undefined && state.cardDetails.FirstName.length > 0) {
            username = state.cardDetails.FirstName;
          } else if (state.cardDetails.Title !== null && state.cardDetails.Title !== undefined && state.cardDetails.Title.length > 0) {
            username = `${state.cardDetails.Title} ${state.cardDetails.LastName}`;
          } else {
            username = state.cardDetails.LastName;
          }
          this.setState({store: {
            name: username,
            balance: state.cardDetails.Balance,
            retailers: state.ui.balance.brands,
            offers: state.ui.balance.offers,
          }}, () => {
            SessionStorage.setSessionStorageItem('store', JSON.stringify(this.state.store));
          })

        }
        
      });
  }
  componentWillUnmount = () => {
      window.removeEventListener("resize", this.updateDimensions);
      // SessionStorage.clearSessionStorage();
      SessionStorage.removeSessionStorageItem('bal');
      SessionStorage.removeSessionStorageItem('store');
  }

  sendEvent = (category, action, label) => {
    ReactGA.event({
      category: category,
      action: action,
      label: label
    })
  }

  render() {
    let retailers = this.state.store.retailers.map((brand, index) => {
      return <Retailer key={index}>
        <RetailerLink href={brand.brandURL} target="_blank" onClick={() => {this.sendEvent('CardActivation', 'Retailer', brand.brandImageAlt)}}>
          <RetailerImg src={brand.brandImageSrc} alt={brand.brandImageAlt}/>
        </RetailerLink>
      </Retailer>
    });

    let offers = this.state.store.offers.map((offer, index) => {
      return <Offer key={index}>
        <OfferLink href={offer.offerURL} target="_blank" onClick={() => {this.sendEvent('CardActivation', 'Promotion', offer.offerImageAlt)}}>
          <OfferImg src={offer.offerImageSrc} alt={offer.offerImageAlt}/>
        </OfferLink>
      </Offer>
    });

    return (
      <Fragment>

        <Helmet>
          <title>{this.props.appState.ui.balance.meta.title}</title>
          <meta name="description" content={this.props.appState.ui.balance.meta.description} />
        </Helmet>

        <Header header={this.props.appState.ui.header} url={this.props.url}/>

        <Main site={this.props.appState.ui.site} >
          <Card card={this.props.appState.ui.balance.card} header={StyledH2} name={this.state.store.name}>

            { offers.length > 1 ?
              <DoubleOffer retailers={retailers} offers={offers} windowSize={this.state.width} balance={this.state.store.balance} content={this.props.appState.ui.balance.card}/>
            :
              <SingleOfferApp retailers={retailers} offers={offers} balance={this.state.store.balance} content={this.props.appState.ui.balance.card}/>
            } 

            <CardFooter>
              <StyledButton to={`${this.props.url === '/' ? '' : this.props.url}/pin-retrieval`}
                color={this.props.appState.ui.cardActivation.buttons.forward.textColor} 
                background={this.props.appState.ui.cardActivation.buttons.forward.backgroundColor}
                border={this.props.appState.ui.cardActivation.buttons.forward.borderColor}>
                {this.props.appState.ui.balance.buttons.forward.text}</StyledButton>
            </CardFooter>

          </Card>
        </Main>

        <Footer footer={this.props.appState.ui.footer} url={this.props.url} clientTerms={this.props.appState.ui.clientTerms} />

      </Fragment>
    );
  };
};

export default BalancePage;


// WEBPACK FOOTER //
// ./src/containers/BalancePage/BalancePage.js